import { SendGiftReviewTemplate } from '@hero/templates';

export default function SendGiftReviewPage() {
  return <SendGiftReviewTemplate />;
}
